import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
let inflight = null;

/** Fetches /settings/public once and caches it for the session. */
export function usePublicSettings() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache) { setData(cache); return; }
    if (!inflight) {
      inflight = api.get("/settings/public")
        .then((r) => { cache = r.data; return r.data; })
        .catch(() => ({}));
    }
    inflight.then((d) => setData(d));
  }, []);
  return data;
}

/** Invalidate cache after admin edit. */
export function invalidatePublicSettings() {
  cache = null;
  inflight = null;
}
